/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */

import cn from "classnames";
import * as React from "react";
import { withBoundField } from "~/components/form/BoundField/BoundField";
import InputLabel from "~/components/form/InputLabel";
import type FormFieldProps from "../../../components/form/FormFieldProps";
import RadioButtonGroupInternal from "./RadioButtonGroupInternal";
const styles = require("./style.less");

interface RadioButtonGroupProps<TValue> extends FormFieldProps<TValue> {
    horizontal?: boolean;
    autoFocus?: boolean;
    label?: string | JSX.Element;
    error?: string;
    className?: string;
    noMargin?: boolean;
    validate?(value: TValue): string;
    onValidate?(value: string): void;
    accessibleName?: string;
}

interface RadioButtonGroupState {
    error?: string;
    showExternalError: boolean;
}

//eslint-disable-next-line react/no-unsafe
class RadioButtonGroup<TValue> extends React.Component<RadioButtonGroupProps<TValue>, RadioButtonGroupState> {
    constructor(props: RadioButtonGroupProps<TValue>) {
        super(props);
        this.state = {
            showExternalError: true,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: RadioButtonGroupProps<TValue>) {
        const isNewExternalErrorAvailable = nextProps.error !== this.props.error;
        if (isNewExternalErrorAvailable) {
            this.setState({ showExternalError: true });
        }
    }

    handleChange(event: any, value: any) {
        if (this.props.validate) {
            const result = this.props.validate(value);
            this.setState({ error: result });
            if (this.props.onValidate) {
                this.props.onValidate(result);
            }
        }
        this.setState({ showExternalError: false });
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    render() {
        const { className, value, label, validate, children, error, onChange, onValidate, horizontal, noMargin, accessibleName, ...otherProps } = this.props;

        const err = this.state.error || (this.state.showExternalError && error);

        const classes = [styles.radioButtonGroup, className];
        if (horizontal) {
            classes.push(styles.horizontal);
        }

        return (
            <div className={cn(styles.container, { [styles.topMargin]: !noMargin })}>
                <InputLabel label={label!} />
                <RadioButtonGroupInternal accessibleName={accessibleName} className={cn(classes)} onChange={(e: any, v: any) => this.handleChange(e, v)} floatingLabelText={label} valueSelected={value} {...otherProps}>
                    {children}
                </RadioButtonGroupInternal>
                {err && <div className={styles.errorText}>{err}</div>}
            </div>
        );
    }
}

export class StringRadioButtonGroup extends RadioButtonGroup<string> {}

export class BooleanRadioButtonGroup extends RadioButtonGroup<boolean> {}

export const BoundStringRadioButtonGroup = withBoundField(StringRadioButtonGroup);

export const BoundRadioButtonGroup = withBoundField(RadioButtonGroup);

export default RadioButtonGroup;
